import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, LinkIcon, StreamrNewLogoSolo } from '@streamr/tv-ui';
import styled from 'styled-components';
import { BroadcastStateService } from '../../services/broadcaststate/BroadcastStateService';
import { copyToClipboard } from '../../utils/copyToClipboard';
import { formBroadcastUrl } from '../../utils/url';
import { LiveIndicator } from '../LiveIndicator';
import { showToast } from '../popups/ToastPopup';
import { LogoLink } from '../shared/LogoLink';
import { StatusContainer } from '../views/View';
import { QualityBadge } from './QualityBadge';
export function ViewerHeader({ isLive }) {
    const activeBroadcast = BroadcastStateService.getOutput().useRequiredActiveBroadcast();
    const broadcastUrl = formBroadcastUrl(activeBroadcast);
    return (_jsxs(ViewerHeaderRoot, { children: [_jsxs(StatusContainer, { children: [_jsx(StyledLogoLink, { logoImage: _jsx(StreamrNewLogoSolo, {}) }), _jsxs(TitleBox, { children: [isLive && _jsx(LiveIndicator, {}), isLive && _jsx(QualityBadge, {}), _jsxs(BroadcastTitle, { children: ["\u200C", activeBroadcast.name] })] })] }), _jsx("div", { children: _jsx(BaseButton, { onClick: () => {
                        copyToClipboard(broadcastUrl);
                        showToast('Link copied!');
                    }, children: _jsx(LinkIcon, {}) }) })] }));
}
const ViewerHeaderRoot = styled.div `
    --tv-LogoLink-height: 2.75rem;

    display: grid;
    grid-template-columns: 1fr auto;
    padding: 0.75rem 1.5rem;
    align-items: center;

    ${StatusContainer} {
        display: flex;
        align-items: center;
        gap: 1rem;
    }
`;
const TitleBox = styled.div `
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background-color: var(--tv-ui-color-20);
    padding: 0.25rem 0.5rem;
    border-radius: 0.5rem;
`;
const BroadcastTitle = styled.div `
    display: var(--BroadcastTitle_Display, block);
    font-size: 0.875rem;
    line-height: 1.3rem;
    font-weight: 500;
    letter-spacing: 0%;
    color: var(--tv-ui-color-3);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
`;
const StyledLogoLink = styled(LogoLink) `
    padding: 1rem 0;
    svg {
        width: 2rem;
        height: 2rem;
    }
`;
// const StyledLiveViewerCount = styled(LiveViewerCount)`
//     padding: 0.25rem 0.5rem;
//     border-radius: 0.5rem;
//     background-color: var(--tv-ui-color-20);
// `;
const BaseButton = styled(Button) `
    --Button_Width: 3rem;
    --Button_Height: 3rem;
    color: var(--tv-ui-color-3);
`;
